require("slick-carousel");

class window.HomeSlider
    constructor: ->
        @sliderWrapper = $('.home__banners-slider')
        @initSlider()

    initSlider: ->
        self = this
        self.sliderWrapper.each ->
            $(this).slick({
                prevArrow: $(this).siblings('.home-banners-slider__arrow-left')
                nextArrow: $(this).siblings('.home-banners-slider__arrow-right')
                dots: true
                autoplay: true
                autoplaySpeed: 4000
            })


// WEBPACK FOOTER //
// ./assets/javascripts/app/home_slider.coffee